module.exports = __webpack_public_path__ + "img/54_8.466ac385.png";